export const DETECTION_ANALYTICS = {
  "DETECTION: View Obscured Data": () => ({}),
};
